export default function FreeService() {
  const templates = [
    {
      title: '비즈니스 미팅 요청',
      description: '전문적인 미팅 요청 이메일 작성법',
      tag: '상황별 템플릿',
    },
    {
      title: '프로젝트 업데이트',
      description: '효과적인 진행 상황 공유 방법',
      tag: '상황별 템플릿',
    },
    {
      title: '네트워킹 이메일',
      description: '관계 구축을 위한 이메일 전략',
      tag: '상황별 템플릿',
    },
  ];

  return (
    <section id="free-service" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <p className="text-teal-600 text-sm font-semibold uppercase tracking-wider mb-4">
              Free Email Templates
            </p>
            <h2 className="text-5xl font-bold text-gray-900 mb-6">
              비즈니스 영어
              <br />
              이메일 가이드
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed mb-8">
              실무에서 바로 사용할 수 있는 영어 이메일 템플릿과 작성 가이드를 무료로 제공합니다.
              상황별로 정리된 템플릿으로 자신감 있게 소통하세요.
            </p>
            <button className="inline-flex items-center space-x-2 bg-teal-500 text-white px-8 py-4 rounded-lg font-medium hover:bg-teal-600 transition-colors whitespace-nowrap cursor-pointer">
              <span>템플릿 다운로드</span>
              <i className="ri-download-line text-xl"></i>
            </button>
          </div>

          <div className="relative">
            <div className="space-y-6">
              {templates.map((template, index) => (
                <div
                  key={index}
                  className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer"
                  style={{
                    transform: `translateX(${index * 20}px) translateY(${index * 20}px)`,
                  }}
                >
                  <div className="flex items-start justify-between mb-3">
                    <h3 className="text-xl font-bold text-gray-900">{template.title}</h3>
                    <span className="px-3 py-1 bg-teal-100 text-teal-700 text-xs font-medium rounded-full whitespace-nowrap">
                      {template.tag}
                    </span>
                  </div>
                  <p className="text-gray-600 text-sm">{template.description}</p>
                  <div className="mt-4 flex items-center text-teal-600 text-sm font-medium">
                    <span>자세히 보기</span>
                    <i className="ri-arrow-right-line ml-1"></i>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
